
import { WebObjectTypeModel } from '../../Models/web-object-type-model';

export class webobjecttypeMock {

  private static models: WebObjectTypeModel[];
  private static  idCounter = 0;

  public static initMocks(){
    //set icon,name,id
    webobjecttypeMock.models = [];
    webobjecttypeMock.models.push({id:"iu2gfin32f23", name: "Images", icon :"image"});
    webobjecttypeMock.models.push({id:"ewhfiuewnfewyy", name: "Links", icon :"link"});
    webobjecttypeMock.models.push({id:"gffnweftewf7775", name: "Buttons", icon :"radio_button_checked"});
    webobjecttypeMock.models.push({id:"eofoefoefjof", name: "Text", icon :"text_format"});
    webobjecttypeMock.models.push({id:"zxcawraseasz123", name: "Select", icon :"arrow_drop_down_circle"});
    webobjecttypeMock.models.push({id:"zxcawraseasz1245", name: "Other", icon :"web"});
  }

  public static findByObjectId(id: string):WebObjectTypeModel{
    let m = webobjecttypeMock.models;
    for(let i = 0; i< m.length; i++){
      if(id == m[i].id) return m[i];
    }
    return null;
  }

  public static findById(id:string):WebObjectTypeModel{
    let m = webobjecttypeMock.models;
    for(let i = 0; i< m.length; i++){
      if(id == m[i].id)
       return m[i];
    }
    return null;
  }

  public static getItems():WebObjectTypeModel[]{
    return webobjecttypeMock.models;
  }
}
